import store from './store.js';

import {
    LiveSearch,
    CollectionComponent,
    ContinuousCollectionComponent,
    SyncsWithUrl,
    ResetsPage,
    PaginationNav,
} from 'clockvine-vue';

// Essentially a copy of Clockvine's component, smooth-scrolling integrated
import BasePagination from './components/BasePagination.vue';

export default {
    store,

    data: {
        params: {
            orderBy: 'title asc',
            page: 1,
            search: '',
            type: '',
            topic: '',
            service: '',
            category: '',
        },
    },

    computed: {
        types: {
            get() {
                return this.params.type.length ? this.params.type.split(',') : []
            },
            set(value) {
                this.params.type = value.length ? value.join(',') : ''
            }
        },
        topics: {
            get() {
                return this.params.topic.length ? this.params.topic.split(',') : []
            },
            set(value) {
                this.params.topic = value.length ? value.join(',') : ''
            }
        },
        service: {
            get() {
                return this.params.service.length ? this.params.service.split(',') : []
            },
            set(value) {
                this.params.service = value.length ? value.join(',') : ''
            }
        },
        filtersSelected() {
            return this.params.type.length || this.params.topic.length || this.params.service.length ? true : false;
        },
        nextPage() {
            const urlParams = new URLSearchParams(location.search);
            urlParams.set('page', this.params.page + 1);
            return '?' + urlParams.toString();
        },
    },

    methods: {
        scroll() {
            const el = this.$refs.listingTop;

            this.$smoothScroll({
                scrollTo: el
            })
        },
        clearFilters() {
            this.params.page = '';
            this.params.type = '';
            this.params.topic = '';
            this.params.service = '';
            this.params.category = '';
        }
    },

    mixins: [
        new SyncsWithUrl('params', {
            page: () => false,
            orderBy: 'title asc'
        }),
        new ResetsPage(),
    ],

    components: {
        resources: CollectionComponent.for('resources'),
        resourceTypes: CollectionComponent.for('resourceTypes'),
        resourceTopics: CollectionComponent.for('resourceTopics'),
        resourceServices: CollectionComponent.for('resourceServices'),
        blogs: CollectionComponent.for('blogs'),
        blogCategories: CollectionComponent.for('blogCategories'),
        search: LiveSearch,
        pagination: BasePagination,
    },
}
